import { render, staticRenderFns } from "./premium-banner.vue?vue&type=template&id=3e6efac4&scoped=true"
import script from "./premium-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./premium-banner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./premium-banner.vue?vue&type=style&index=0&id=3e6efac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6efac4",
  null
  
)

export default component.exports